import React from "react";
import { NotificationProps } from "@/features/notification/Notification";
import { DrawerPageRenderer, PortalDrawer } from "./PortalDrawer";
import { BoxItem } from "./types";
import { SelectedItemProvider } from "./SelectedItemContext";

export interface RootSubscriptionDrawerProps {
  open?: boolean;
  contents?: DrawerPageRenderer;
  onExit: () => void;
  selectedItem?: BoxItem;
  notify: ({ title, message }: NotificationProps) => void;
}

export const RootBoxItemDrawer = ({
  open,
  contents,
  onExit,
  selectedItem,
  notify,
}: RootSubscriptionDrawerProps) => {
  return (
    <PortalDrawer
      open={open}
      onExit={onExit}
      notify={notify}
      goToFirstPage={() => {}}
      title={"Edit Item"}
      contents={(nav) =>
        contents !== undefined && selectedItem !== undefined ? (
          <SelectedItemProvider boxItem={selectedItem}>
            {contents({ ...nav })}
          </SelectedItemProvider>
        ) : null
      }
    />
  );
};
